import { render, staticRenderFns } from "./AddWorkerAudit.vue?vue&type=template&id=b954a8c4&scoped=true"
import script from "./AddWorkerAudit.vue?vue&type=script&lang=js"
export * from "./AddWorkerAudit.vue?vue&type=script&lang=js"
import style0 from "./AddWorkerAudit.vue?vue&type=style&index=0&id=b954a8c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b954a8c4",
  null
  
)

export default component.exports